module.exports = __webpack_public_path__ + "static/media/undraw_Online_calendar_re_wk3t.119de4aa.svg";